<script lang="ts">
  import { _ } from 'svelte-i18n';
  import Title from '../../misc/Title.svelte';
  import { AppState, SetNotification } from '../../../etc/stores';
  import Text from '../../typography/Text.svelte';

  import { replaceVariables } from '../../../i18n';
  import flags from '../../../etc/flagKeys';

  const t = (text: string, values: any = {}) => {
    return replaceVariables($_(`messages.${text}`), values);
  };

  const close = () => {
    SetNotification('', true);
  };

  const { welcomeTitle, welcomeDescription } = $AppState.settings;
</script>

<div class="twism-popup-grettings--container">
  <div class="twism-popup-grettings--close" on:click={close}>
    <img
      src={`${process.env.BASE_URL}/images/close-icon.svg`}
      alt="Close message icon"
    />
  </div>
  {#if welcomeTitle !== ''}
    <div
      class={welcomeDescription !== '' ? 'twism-popup-grettings--title' : ''}
    >
      <Title fontSize="20px">{welcomeTitle || t('greeting.title')}</Title>
    </div>
  {/if}
  {#if welcomeDescription !== ''}
    <Text
      type="medium"
      color="#012A5A"
      textAlign="center"
      class="twism-popup-grettings--description"
    >
      {welcomeDescription || t('greeting.subtitle')}
    </Text>
  {/if}
</div>

<style lang="scss">
  @use './styles.scss' as *;

  :global(.twism-popup-grettings--description) {
    opacity: 0.8;
    word-break: break-word;
  }

  .twism-popup-grettings {
    &--container {
      background-color: #ffffff;
      background-image: var(--twism-theme-slightGradient);
      background-size: 100% 136px;
      background-position: center -18px;
      background-repeat: no-repeat;
      box-shadow: 0px 14px 48px -13px rgba(4, 33, 67, 0.26);
      border-radius: 16px;
      width: 280px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      padding: 40px;

      @media screen and (max-width: 468px) {
        width: auto;
      }
    }

    &--title {
      margin-bottom: 8px;
    }

    &--close {
      right: 0;
      top: 0;
      position: absolute;
      cursor: pointer;
      padding: 16px;
    }
  }
</style>
